export const charterEmail = 'charter@airacer.com';
export const infoEmail = 'info@airacer.com';
export const marketingEmail = 'marketing@airacer.com';
export const supportEmail = 'lauren.kim@airacer.com';
